import React, { useState, useEffect } from 'react';
import AddressForm from '../../components/forms/AddressForm';
import AddressTable from '../../components/tables/AddressTable';
import { isAuthenticated } from '../../store/action/auth';
import { createAddress, getAddresses } from '../../store/action/address';
import Modal from "../../components/molecules/Modal";
import {getGeocode} from "../../store/action/location";
import {trackEvent} from "../../services/analytics";
import PaymentWarning from "../../components/warnings/Payment";
import Freshchat from "../../components/atoms/FreshChat";

const CreateAddress = () => {
  const { user, token } = isAuthenticated();
  const [ addressForm, setAddressForm ] = useState(false);
  const [ addresses, setAddresses ] = useState([]);
  const [ loading, setLoading ] = useState(true);
  const [ locLoading, setLocLoading ] = useState(false);
  const initialState = {
    addressId:'',
    addressName:'',
    addressDetails:'',
    addressPIC:'',
    coordinate: {
      latitude:'',
      longitude:''
    },
    postalCode:0,
    provinceId:0,
    provinceName:'-',
    cityId:0,
    cityName:'-',
    districtId:0,
    districtName:'-',
    subdistrictId:0,
    subdistrictName:'-',
    stores:[],
    formattedStores:[],
    error:false,
    success:false
  };
  const [ values, setValues ] = useState(initialState);

  useEffect(() => {
    _getAddress()
  }, []);

  const _getAddress = () => {
    getAddresses()
      .then(res => {
        if(res.success){
          let addresses = res.addresses.reduce((result, i) => {
            result.push({
              addressId:i._id,
              addressName:i.name,
              addressPIC:i.PIC,
              addressDetails: i.details,
              addressNote:i.note,
              coordinate:i.coordinate,
              postalCode: i.postalCode,
              provinceId: i.provinceId,
              provinceName: i.provinceName,
              stores: i.stores,
              cityId: i.cityId,
              cityName: i.cityName,
              districtId: i.districtId,
              districtName: i.districtName,
              subdistrictId: i.subdistrictId,
              subdistrictName: i.subdistrictName
            });
            return result
          }, []);
          setLoading(false);
          setAddresses(addresses)
        } else {
          alert("Gagal ambil alamat. Mohon ulangi kembali")
        }
      })
  };

  const onRefresh = () => {
    _getAddress()
  };

  const onSelectLocation = async (a,c) => {
    setLocLoading(true);
    const res = await getGeocode(token, c);
    if (res.success){
      setValues({
        ...values,
        error: false,
        success:false,
        addressDetails:a,
        coordinate:c,
        ...res.location
      })
    } else {
      alert("Alamat yang Anda pilih kurang spesifik. Usahakan masukan alamat seperti nama toko, nama komplek perumahan atau nama jalan. Terima kasih.");
      setValues({
        ...values,
        error: false,
        success:false
      });
    }
    setLocLoading(false);
  };

  const onLocationChange = address => {
    setValues({...values, addressDetails:address})
  };

  const onStoreChange = stores => {
    setValues({...values, stores})
  };

  const handleChange = name => event => {
    setValues({ ...values, error: false, success:false, [name]: event.target.value });
  };

  const onSubmitNewAddress = () => {
    setLoading(true);
    if (!values.addressName) {
      alert( "Nama kontak di lokasi tempat masih kosong. Mohon diisi");
      setLoading(false);
      return
    }
    if (!values.addressPIC) {
      alert( "Nomor telepon kontak di lokasi masih kosong. Mohon diisi");
      setLoading(false);
      return
    }
    if (!values.addressNote) {
      alert( "Keterangan tempat masih kosong. Mohon diisi");
      setLoading(false);
      return
    }

    const reducedStores = values.stores.reduce((r,i) => {
      r.push(i.value);
      return r
    },[]);

    let address = {
      ...values,
      stores:reducedStores
    };

    delete address.addresses;


    createAddress(address)
      .then(data => {
        if(data.error) {
          setValues({...values, error: data.error})
        } else {
          trackEvent("Address Created",{
            action: "track",
            category: "Addresses",
            label: 'Create New Address',
            event: "Click"
          });
          setValues(initialState);
          alert("Alamat berhasil ditambahkan");
          window.location.reload();
        }
      })
  };

  const showSuccess = () => {
    if(values.success){
      return (
        <div
          className="alert alert-success mb-0"
          style={{display: values.success ? '' : 'none'}}
          >
          Berhasil dibuat
        </div>
      )
    }
  };

  const showError = () => {
    if(values.error){
      return (
        <div
          className="alert alert-danger mb-0"
          style={{display: values.error ? '' : 'none'}}
          >
          {values.error}
        </div>
      )
    }
  };

  const handleModalClose = () => {
    setAddressForm(false)
  };

  const handleModalOpen = () => {
    setAddressForm(true);
    setValues(initialState)
  };

  const modalView = () => {
    return (
        <Modal
            show={addressForm}
            onHide={handleModalClose}
            loading={loading}
            title="Buat Alamat Baru"
            bodyClassName="p-0"
            buttons
            type="yesno"
            lbText="Kembali"
            rbText="Simpan"
            lbClick={handleModalClose}
            rbClick={() => onSubmitNewAddress()}
            footerStyle={{justifyContent:'flex-end'}}
        >
          { showSuccess() }
          { showError() }
          <div className="p-4">
            <AddressForm
                button={false}
                data={values}
                handleChangeLocation={onLocationChange}
                handleChangeStore={onStoreChange}
                handleChange={handleChange}
                locationLoading={locLoading}
                onSubmitText="Tambah Alamat"
                onSelectLocation={onSelectLocation}
            />
          </div>
        </Modal>
    );
  };

  let addressView;
  if (loading) {
    addressView = (
        <div>
          <div className="p-4 d-flex justify-content-between">
            <h5>Alamat Tersimpan </h5>
          </div>
          <div className="pl-4 pb-4">loading...</div>
        </div>

    )
  } else if (addresses.length === 0) {
    addressView = (
        <div className="text-center pb-5">
          <div className="p-4 mb-4 d-flex justify-content-between">
            <h5>Alamat Tersimpan </h5>
          </div>
          <h4>Anda belum punya alamat tersimpan</h4>
          <p>Buat alamat untuk mempermudah pengiriman Anda!</p>
          <button
              onClick={handleModalOpen}
              className="btn btn-primary col-3 mt-2">
            Buat Alamat
          </button>
        </div>
    )
  } else {
    addressView = (
       <div>
         <div className="p-4">
           <div className=" d-flex justify-content-between">
             <h5>Alamat Tersimpan </h5>
             <button
                 className="btn btn-sm btn-primary"
                 onClick={handleModalOpen}
             >
               Tambah Alamat
             </button>
           </div>
         </div>

         <AddressTable
             data={addresses}
             loading={loading}
             onRefresh={onRefresh}
         />
       </div>
    )
  }

  return (
      <div>
        <PaymentWarning user={user} type={"top"}/>
        <div className="bg-white rounded shadow">
          { modalView() }
          { addressView }
        </div>
      </div>
  )

};


export default CreateAddress;
